import { SiteConfigManager } from '@atlas/core';

const useIsSwipeGrid = () => {
  const setting = SiteConfigManager.getConfig(
    'config.config.sportsbook.mobileGridViewType',
    'scroll',
  );

  return setting === 'swipe';
};

export default useIsSwipeGrid;
